import animation, { slideInUp, slideInUpInitial } from '@helpers/animation';
import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';
const Container = styled.div `
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  ${({ align }) => align === 'center' &&
    css `
      align-items: center;
      text-align: center;

      ${Title} {
        align-items: center;
      }
    `}

  ${({ size }) => size === 'small' &&
    css `
      ${Title} {
        ${fonts.gillSans.semiBold};
        font-size: 20px;
        line-height: 28px;
        letter-spacing: 0.15em;
        margin: 0 0 16px;

        @media ${from(Device.Tablet)} {
          ${fonts.gillSans.semiBold};
          font-size: 28px;
          line-height: 38px;
          letter-spacing: 0.15em;
          margin: 0 0 16px;
        }
      }

      ${Subtitle} {
        font-size: 16px;
        line-height: 21px;
      }
    `}

  ${({ size }) => size === 'large' &&
    css `
      ${Title} {
        ${fonts.gillSans.semiBold};
        font-size: 28px;
        line-height: 38px;
        letter-spacing: 0.13em;
        margin: 0 0 16px;

        @media ${from(Device.Tablet)} {
          ${fonts.gillSans.semiBold};
          font-size: 40px;
          line-height: 50px;
          letter-spacing: 0.13em;
          margin: 0 0 16px;
        }

        @media ${from(Device.Desktop)} {
          font-size: 50px;
          line-height: 64px;
        }
      }

      ${Subtitle} {
        font-size: 16px;
        line-height: 21px;
      }
    `}

    @media ${from(Device.TabletLarge)} {
    ${() => Subtitle}, ${() => Title} {
      ${slideInUpInitial};
    }

    ${({ isActive }) => isActive &&
    css `
        ${() => Subtitle} {
          ${slideInUp(isActive, 375, 0, animation.easeInOutCubic)};
        }

        ${() => Title} {
          ${slideInUp(isActive, 375, 50, animation.easeInOutCubic)};
        }
      `}
  }
`;
const Title = styled.span `
  display: flex;
  align-items: flex-start;
  color: ${cssVar('accentColor')};
  flex-direction: column;
  margin: 0 0 16px;
  text-transform: uppercase;
`;
const Subtitle = styled.span `
  display: block;
  color: ${cssVar('fgColor')};
  ${fonts.gillSans.regular};
  font-size: 16px;
  line-height: 21px;
  margin: 0 0 4px;
  text-transform: uppercase;
`;
export default {
    Container,
    Subtitle,
    Title,
};
